import { getRangeInlineNodeNames, getRangeAncestorNodeNames } from '@atlaskit/editor-common/utils';
import { fg } from '@atlaskit/platform-feature-flags';
export function getRendererRangeInlineNodeNames(_ref) {
  var actions = _ref.actions,
    pos = _ref.pos;
  if (!fg('editor_inline_comments_on_inline_nodes')) {
    return undefined;
  }
  var doc = actions.doc;
  if (!pos || !doc) {
    return undefined;
  }
  var inlineNodeNames = getRangeInlineNodeNames({
    doc: doc,
    pos: pos
  });
  return inlineNodeNames;
}
export function getRendererRangeAncestorNodeNames(_ref2) {
  var actions = _ref2.actions,
    pos = _ref2.pos;
  if (!fg('cc_comments_log_draft_annotation_ancestor_nodes')) {
    return undefined;
  }
  var doc = actions.doc;
  if (!pos || !doc) {
    return undefined;
  }
  var ancestorNodeNames = getRangeAncestorNodeNames({
    doc: doc,
    pos: pos
  });
  return ancestorNodeNames;
}